import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AlertService, IAlertType, RequestsStoreService } from "../../../../_shared/services";
import { Requests, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { RouterLink } from "@angular/router";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

@Component({
  selector: 'app-requests-overview',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    CurrencyPipe,
    ClrIconModule
  ],
  templateUrl: './requests-overview.component.html',
  styleUrl: './requests-overview.component.sass'
})

export class RequestsOverviewComponent implements OnInit, OnChanges {
  requests: Requests[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusLabel = 'label-light-blue';
  statusText = '';

  @Input() status!: string;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'alert-info', icon: 'info-circle'},
    { state: 'rejected', display: 'Abgelehnt', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'too expensive', display: 'Zu teuer', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'ignored', display: 'Ignoriert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'answered', display: 'Beantwortet', label: 'alert-info', icon: 'info-circle'},
    { state: 'favored', display: 'Auftrag', label: 'alert-success', icon: 'check-circle'},
  ];

  constructor(
    private reqss: RequestsStoreService,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loadList(this.status);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    this.loadList(this.status);
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(requeststatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === requeststatus)
  };

  getCellStatus(requeststatus: string) {
    const statusline = this.findButtonStatus(requeststatus, this.statusButtons);
    return {
      'statusLabel' : this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(requeststatus: string) {
    return "alert " + this.getCellStatus(requeststatus).statusLabel + " alert-sm";
  }

  loadList(status: string) {
    this.reqss.getRequests('0',0, status).subscribe({
      next: data => {
        this.requests = data?.object ?? [];
        if (this.requests.length === 0) {
          this.alertDispatcher.show({
            message: 'Keine Anfragen gefunden.',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      }
    });
  }
}
